export default {
	AUTH_REQUEST: '@auth/AUTH_REQUEST',
	AUTH_SUCCESS: '@auth/AUTH_SUCCESS',
	AUTH_FAILURE: '@auth/AUTH_FAILURE',
	AUTH_LOGOUT : '@auth/AUTH_LOGOUT',
	AUTH_VERIFY_REQUEST: '@auth/AUTH_VERIFY_REQUEST',
	AUTH_VERIFY_SUCCESS: '@auth/AUTH_VERIFY_SUCCESS',
	AUTH_VERIFY_FAILURE: '@auth/AUTH_VERIFY_FAILURE',
}
